
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import {
		logisticsTplList,
		providerLogisticsTplList
	} from '@/api/logistics';

	@Component({
		name: 'logistics-template',
		components: {
			PageFooter
		}
	})
	export default class LogisticsTemplate extends Vue {
		private memberKey = '';
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;

		private mounted() {
			this.getList();
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.memberKey
			}
			try {
				const res: any = await providerLogisticsTplList(params);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (err) {
				console.log(err)
			}
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.memberKey = '';
			this.getList();
		}

		private toDesc(id: number) {
			this.$router.push({
				name: 'Desc_List',
				query: {
					id: id + ''
				}
			})
		}
	}
